<div class="flex flex-col min-w-[50rem] min-h-[29rem] align-items-center">
    <div class="w-full mt-3 relative">
        <sigecom-input-search-new (searchChange)="filterIncTxNome($event)" placeholder="Pesquise" />
    </div>


    <div class="pt-8 pb-8 overflow-y-scroll max-h-72">

        <div class="flex flex-col gap-3">
            <div *ngFor="let item of participants?.content">
                <sigecom-list-item ngClass="flex" bgColor="bg-[#E5E7EB] rounded-xl">
                    <div class="flex justify-between items-center">
                        <div class="flex gap-3">
                          <!-- item.inscricaoEtapaDto.incBlCabecaChave -->
                            <div class="bg-[#012169] flex rounded-full justify-center p-2 items-center w-6 h-6 "
                                *ngIf="false">
                                <fa-icon class="text-[#E9CA26] text-xs" icon="key"></fa-icon>
                            </div>
                            <p class="font-bold text-[#012169]">{{ item.inscricaoEtapaDto.ineObjInscricao.incTxResumo }}
                            </p>
                            <!-- <sigecom-menu-bar-item (clickAction)="openModalViewParticipants(item)" icon="eye"
                                color="sigecom-info" title="Apagar" /> -->
                        </div>
                        <sigecom-button (buttonClicked)="addParticipant(item)" class="text-sigecom-info" type="info"
                            icon="plus" title="ADICIONAR" />
                    </div>
                </sigecom-list-item>
            </div>
        </div>
    </div>

<sigecom-pagination-list class="" [totalPages]="participants?.totalPages ?? 1" [maxDisplayedPages]="10" (pageChange)="onPageChange($event)" />
